// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'cadastros.categoriasHub.eyebrow': 'Categorias',
    'cadastros.categoriasHub.fleet': 'Frota',
    'cadastros.categoriasHub.people': 'Pessoas',
    'cadastros.categoriasHub.places': 'Locais',
    'cadastros.categoriasHub.assets': 'Ativos',
    'cadastros.categoriasHub.modalities': 'Modalidades',
    'cadastros.categoriasHub.naoAtendidoMotivos': 'Motivos de não atendimento',
    'cadastros.categoriasHub.status': 'Status',
  },
  en: {
    'cadastros.categoriasHub.eyebrow': 'Categories',
    'cadastros.categoriasHub.fleet': 'Fleet',
    'cadastros.categoriasHub.people': 'People',
    'cadastros.categoriasHub.places': 'Places',
    'cadastros.categoriasHub.assets': 'Assets',
    'cadastros.categoriasHub.modalities': 'Modalities',
    'cadastros.categoriasHub.naoAtendidoMotivos': 'Unattended reasons',
    'cadastros.categoriasHub.status': 'Status',
  },
  es: {
    'cadastros.categoriasHub.eyebrow': 'Categorías',
    'cadastros.categoriasHub.fleet': 'Flota',
    'cadastros.categoriasHub.people': 'Personas',
    'cadastros.categoriasHub.places': 'Lugares',
    'cadastros.categoriasHub.assets': 'Activos',
    'cadastros.categoriasHub.modalities': 'Modalidades',
    'cadastros.categoriasHub.naoAtendidoMotivos': 'Motivos de no atendimiento',
    'cadastros.categoriasHub.status': 'Estado',
  },
}
